import { render, staticRenderFns } from "./inviteIndex.vue?vue&type=template&id=16d04f6a&"
import script from "./inviteIndex.vue?vue&type=script&lang=js&"
export * from "./inviteIndex.vue?vue&type=script&lang=js&"
import style0 from "./inviteIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports